import React from 'react'
import { Col, FormGroup, Label } from 'reactstrap'
export var ODEntityLabeled = function (props) {
  var name = props.name,
    label = props.label,
    children = props.children,
    _a = props.labelMDSize,
    labelMDSize = _a === void 0 ? 3 : _a
  return React.createElement(
    FormGroup,
    { row: true },
    React.createElement(
      Col,
      { md: labelMDSize },
      React.createElement(Label, { htmlFor: name + '-input', style: { paddingTop: 7 } }, label)
    ),
    React.createElement(Col, { xs: '12', md: 12 - labelMDSize }, children)
  )
}
//# sourceMappingURL=ODEntityLabeled.js.map
